export default __webpack_public_path__ + "static/media/card-w-app@3x.ad1697c0.png";